import { IoChevronDown, IoChevronUp } from 'react-icons/io5';

import './style.scss';

export interface TabItem {
    title: string;
    filter: string;
    isSmall?: boolean;
}

interface Options {
    classParent?: string;
    itens: Array<TabItem>;
    selectedItem?: TabItem;
    smallItens?: boolean;
    onChange: (selectItem: TabItem) => void;
}

const NavTab = ({ classParent, itens, selectedItem, smallItens, onChange }: Options) => {
    return (
        <>
            <nav className="tabs">
                <ul className={`flex-col md:flex-row ${classParent}`}>
                    {itens.map((item, index: number) => (
                        <li
                            key={index}
                            className={[
                                item.isSmall && !smallItens ? 'text-xs' : 'text-sm',
                                smallItens ? 'text-[11px]' : 'text-sm',
                                selectedItem?.filter === item.filter ? ' active bg-blue-bb md:bg-transparent' : 'bg-none'
                            ].join(' ')}
                        >
                            <button
                                onClick={() => onChange(item)}
                                className={`flex items-center justify-between md:justify-center px-16 text-left md:text-center md:px-0 ${
                                    selectedItem?.filter === item.filter ? 'text-white-bb md:text-black-bb' : ''
                                }`}
                            >
                                {item.title}
                                <div className="md:hidden">{selectedItem?.filter === item.filter ? <IoChevronUp /> : <IoChevronDown />}</div>
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    );
};

export default NavTab;
